import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import type { UserProfile } from '@partiri-cloud/types';

/**
 * @file user.ts
 * Class for the users client
 * Handles all the profile data
 */
export class UserApi {
  protected endpoint = '/user'

  constructor(private readonly http: HttpClient) { }

  /**
   * Get user profile
   */
  public read(): Observable<UserProfile> {
    return this.http.get<UserProfile>(this.endpoint)
  }

  /**
   * Update user profile
   */
  public update(user: UserProfile): Observable<null> {
    return this.http.put<null>(this.endpoint, user)
  }

  /**
   * Request for account deletion
  */
  public delete(): Observable<boolean> {
    return this.http.delete<boolean>(this.endpoint)
  }
}
